import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ProtectedRoute from '../components/routes/ProtectedRoute';
import ScrollToTop from '../components/routes/ScrollToTop';
import '../configs/config'
// import ErrorBoundary from '../components/shared/ErrorBoundary';

const App = lazy(() => import('../components/App'));
const ChildApp = lazy(() => import('../components/ChildApp'));
const Content = lazy(() => import('../components/Content'));
const Admin = lazy(() => import('../components/Admin'));

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Router>
      <ScrollToTop />
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <ProtectedRoute path='/app' component={App} />
          <Route path='/child-app' component={ChildApp} />
          <Route path='/admin' component={Admin} />
          <Route path='/' component={Content} />
        </Switch>
      </Suspense>
    </Router>,
    document.getElementById('page_root')
  )
})